import {IAppError} from "@pg-mono/request-state";

export function isValidationError(error: unknown): error is {appError: IAppError} {
    return typeof error === "object" && error !== null && "appError" in error && (error.appError as IAppError).status === 400;
}
